import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-university-birmingham',
  templateUrl: './university-birmingham.component.html',
  styleUrls: ['./university-birmingham.component.scss']
})
export class UniversityBirminghamComponent {
  fullName: string;
      email: any;
      date: any;
      emailComponent= '@'
  dateOfBirth: any;
  courseName: any;
      constructor(
          public dialog: MatDialog,
          public dialogRef: MatDialogRef<UniversityBirminghamComponent>,
          @Inject(MAT_DIALOG_DATA) public data: any,
        ) { }
        ngOnInit(): void {
          if(this.data){
            this.fullName = `${this.data.firstName} ${this.data.lastName}`.toUpperCase();
            this.email = this.data.email;
            this.date = this.data.date;
            this.dateOfBirth = this.data.dateOfBirth;
            this.courseName = this.data.courseName
          }
        }
        close(val?: any) {
          this.dialogRef.close(val);
        }
        sendForSignature() {
          this.dialogRef.close('sendForSignature');
      }
}
